module.exports = __webpack_public_path__ + "img/arrows-from-line.45371e15.svg";